import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { PoApproverHelperService } from '../../../services/po-approver-helper.service';

@Component({
  selector: 'app-view-po-approver-modal',
  templateUrl: './view-po-approver-modal.component.html',
  styleUrls: ['./view-po-approver-modal.component.scss']
})
export class ViewPoApproverModalComponent implements OnInit {

  public title !: string;
  public approvalList: any = undefined;
  public po_number!: any;

  constructor(public bsModalRef: BsModalRef,
    private _tostrService: ToastrService,
    private _poApproverService: PoApproverHelperService) { }

  ngOnInit(): void {
    this.getPOApproverList();
  }

  private getPOApproverList() {
    this._poApproverService.getPOApproverList(this.po_number).subscribe((res: any) => {
      if(res){
        this.approvalList = res.data.map((approver:any)=>  {
          console.log(approver.po_approver_profile_details)
          return {...approver.po_approver_profile_details,...{approval_status:approver.approval_status}}});
        // this._poApproverService.getItracerUserInfo(approversGid).subscribe((response:any)=>{
        //   if(response){
        //     this.approvalList = res.data.map((approver:any,index:number)=>{
        //       return {...approver.po_approver_profile_details,...response.data[index],...{approval_status:approver.approval_status}}
        //     })
        //   }
        // }, err => {
        //   this._tostrService.error(err.error.message);
        // })
      }
      this._tostrService.success(res.message);
    }, err => {
      this._tostrService.error(err.error.message);
    });
  }

}
